import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { dataReducer, queriesReducer, errorReducer } from '@wikom/wikom-data';
import { formErrorsReducer } from '@wikom/wikom-form';
import { gridReducer } from '@wikom/wikom-grid';
import { modalReducer } from '@wikom/wikom-modal';
import { wizardReducer } from '@wikom/wikom-wizard';
import { actionLogReducer } from '@wikom/frontend-logger';
import navbarReducer from '../common/reducers/navbarReducer';
import userReducer from '../common/reducers/userReducer';
import layoutReducer from '../common/reducers/layoutReducer';
import gheMeldungReducer from '../vermarktungsrechte/reducers/gheMeldungReducer';
import tokenReducer from '../umstrukturierungsantrag/fertigstellungsmeldung/reducers/tokenReducer';
import rebflaechenNeuReducer from '../rebflaechen/reducers/rebflaechenNeuReducer';
import reduceReducers from '../common/helpers/reduceReducers';
import rvWizardReducer from '../rebflaechen/reducers/rvWizardReducer';
import emailLwkReducer from '../common/reducers/emailLwkReducer';
var rootReducer = combineReducers({
    queries: queriesReducer,
    data: dataReducer(),
    errors: errorReducer,
    user: userReducer,
    grid: gridReducer,
    form: formReducer,
    formErrors: formErrorsReducer,
    modal: modalReducer,
    navbar: navbarReducer,
    wizard: reduceReducers(wizardReducer, rvWizardReducer),
    layout: layoutReducer,
    ghe_meldung_data: gheMeldungReducer,
    fertigstellungsmeldungToken: tokenReducer,
    actionLog: actionLogReducer,
    rebflaechenNeu: rebflaechenNeuReducer,
    emailLwk: emailLwkReducer,
});
export default rootReducer;
